import Incidents from "./Incidents"
import Roadwork from "./Roadwork"
import TravelTimes from "./TravelTimes"
import Train from "./Train"
import Google from "./GoogleTraffic"
import Congestion from "./Congestion"
import ADT from "./ADT"
import Boundaries from "./CityBoundaries"
import DMS from "./DMS"
import Parking from "./Parking"
import RedLight from "./RedLight"
import SpeedCamera from "./SpeedCamera"
import CongestionRegions from "./CongestionRegions"
import Signal from './Signal'
import APS from './APS'
import Bus from './Bus'
import CtaTrain from './CtaTrain'
import MetraRail from './MetraRail'
import LoadingZones from './LoadingZones'
import IntermodalFacilities from "./IntermodalFacilities"
import HistoricalCongestion from "./HistoricalCongestion"
import CCTV from "./CCTV"

const definedModules = [
    Incidents,
    Roadwork,
    TravelTimes,
    Train, 
    DMS,
    Parking, 
    RedLight,
    SpeedCamera,
    Signal,
    APS,
    Congestion,
    CongestionRegions,
    HistoricalCongestion,
    ADT,
    Boundaries,
    Google, 
    Bus,
    CtaTrain,
    MetraRail,
    LoadingZones,
    IntermodalFacilities,
    CCTV
];

export default definedModules;